import { SVGProps, Ref, forwardRef } from 'react';

export const QuestionFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M5.6 5.095c0-.757.243-1.377.636-1.8C6.622 2.882 7.203 2.6 8 2.6c.808 0 1.387.273 1.768.676.386.41.632 1.025.632 1.82 0 1.06-.52 1.529-1.334 2.258-.394.353-.875.787-1.242 1.369C7.442 9.327 7.2 10.059 7.2 11h1.6c0-.642.158-1.077.376-1.423.233-.369.552-.668.958-1.032l.08-.072C10.992 7.778 12 6.877 12 5.095c0-1.125-.354-2.158-1.068-2.916C10.212 1.415 9.192 1 8 1c-1.202 0-2.222.438-2.936 1.207C4.357 2.967 4 3.996 4 5.095z"
                fill="currentColor"
            />
            <path d="M9.15 13.85a1.15 1.15 0 1 0-2.3 0 1.15 1.15 0 0 0 2.3 0" fill="currentColor" />
        </g>
    </svg>
));
QuestionFilledSize16Glyph.displayName = 'QuestionFilledSize16Glyph';
